import 'apps/hiring/styles/components/applicant/targets.scss';
import React from 'react';
import { Redirect } from 'library/util/core-router';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import EvaluateTargetList from 'apps/hiring/components/evaluate-target-list';
import TargetData from 'apps/hiring/components/applicant/target-data';
import Loading from 'components/loading';

class ApplicantTargets extends React.Component {
  static propTypes = {
    targets: PropTypes.array,
    loading: PropTypes.bool,
    reload_graph: PropTypes.func,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    handleAddTargets: PropTypes.func,
    updateActiveTarget: PropTypes.func
  }

  componentDidMount() {
    this.props.updateActiveTarget(resolve(this.props, 'match/params/targetId', null));
  }

  setSelectedTarget = (id) => {
    const openingId   = resolve(this, 'props/match/params/openingId', '');
    const applicantId = resolve(this, 'props/match/params/applicantId', '');

    this.props.updateActiveTarget(id);

    this.props.history.push(
      `/hiring/openings/${openingId}/applicants/${applicantId}/targets/${id}`
    );
  }

  handleAddTargetsAndSet = async (targets) => {
    try {
      const { data } = await this.props.handleAddTargets(targets);
      this.setSelectedTarget(resolve(data, 'connect_targets/target_groupings/0/id', null));
    } catch (e) {
      console.error(e);
    }
    this.props.handleAddTargets(targets);
  }

  onTargetReorder = () => {

  }

  render() {
    const {
      targets,
      reload_graph,
      match,
      loading,
      handleAddTargets
    } = this.props;

    if (loading) {
      return <Loading />;
    }

    const selectedTarget = targets.find(t=>t.id==resolve(match, 'params/targetId', null));

    if (!selectedTarget) {
      return <Redirect to={`/hiring/openings/${resolve(match, 'params/openingId', null)}/applicants/${resolve(match, 'params/applicantId', null)}`} />;
    }

    return (
      <div className="hiring-application-targets">
        <EvaluateTargetList
          opening
          handleAddTargets={this.handleAddTargetsAndSet}
          openingId={resolve(match, 'params/openingId', null)}
          onTargetReorder={this.onTargetReorder}
          reload_graph={reload_graph}
          targets={targets}
          selectedTarget={selectedTarget}
          setSelectedTarget={this.setSelectedTarget}
        />
        <TargetData
          applicantId={resolve(match, 'params/applicantId', null)}
          key={resolve(selectedTarget, 'id')}
          {...selectedTarget} />
      </div>
    );
  }
}

export default ApplicantTargets;
